<div class="tooltip" [ngClass]="['tooltip--'+position, 'tooltip--'+theme]" [class.tooltip--visible]="visible"
  [style.left]="left + 'px'" [style.top]="top + 'px'">
  <div class="grounded-radiants">
    {{tooltip}}

  </div>
</div>